import { createSelector, createSlice } from '@reduxjs/toolkit'
import { initialState } from '../../helpers/ehd'

export const ehdSlice = createSlice({
  name: 'ehd',
  initialState,
  reducers: {
    setQuestionData: (state, action) => {
      state.questionData = action.payload
    },
    setAnswers: (state, action) => {
      state.answers = action.payload
    },
    setCurrentQuestionIndex: (state, action) => {
      state.currentQuestionIndex = action.payload
    },
    setDone: (state, action) => {
      state.done = action.payload
    },
    setBlockingText: (state, action) => {
      state.blockingText = action.payload
    },
    setErrorText: (state, action) => {
      state.errorText = action.payload
    },
    setSending: (state, action) => {
      state.sending = action.payload
    },
    resetState: (state, action) => {
      state.answers = initialState.answers
      state.currentQuestionIndex = initialState.currentQuestionIndex
      state.done = initialState.done
      state.blockingText = initialState.blockingText
      state.errorText = initialState.errorText
      state.sending = initialState.sending
    },
  },
})

export const {
  setQuestionData,
  setAnswers,
  setCurrentQuestionIndex,
  setDone,
  setBlockingText,
  setErrorText,
  setSending,
  resetState,
} = ehdSlice.actions

// Selectors
export const getCurrentAnswer = createSelector(
  [(state) => state.ehd.answers, (state) => state.ehd.currentQuestionIndex],
  (answers, index) => ({
    ...answers[index],
    index,
  }),
)

export const getCurrentAnswerByQuestionId = createSelector(
  (state) => state.ehd.answers,
  (answers) =>
    _.memoize((id) => {
      const answer = _.find(answers, { id })
      return answer
        ? {
            ..._.find(answers, { id }),
            index: _.findIndex(answers, { id }),
          }
        : undefined
    }),
)

export const isEhdEnabled = createSelector(
  (state) => state.app.pages,
  (pages) => !!pages.ehd,
)

export default ehdSlice.reducer
